/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  returnSizeBuyPanel(store) {
    if (store.itemsToPurchase && store.itemsToPurchase[0]) {
      return store.itemsToPurchase[0].size;
    }
  }
};

export default getters;
